import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import ViewHistory from './ViewHistory';
import store from '../../../store';

function ViewHistoryContainer({ onStepSet }) {
  const payments = useSelector(store.select.history.payments);
  const onPay = React.useCallback(() => {
    onStepSet(1);
  }, []);
  return <ViewHistory onPay={onPay} payments={payments} />;
}

ViewHistoryContainer.propTypes = {
  onStepSet: PropTypes.func.isRequired,
};

export default ViewHistoryContainer;
